import { AppGlobalsModule } from 'src/app/app-globals.module';
import { Injectable } from '@angular/core';
import { btnLink } from './btn-link.model';

@Injectable()
export class BtnLinkService {
    constructor() {}
    public getBtnLinksFromCategories(categories: any[]) {
        return categories.map((category) => this.getBtnLink(category.name || category.Name, category.id || category.Id));
    }

    public getBtnLink(name: string, id: number): btnLink {
        return { name, link: AppGlobalsModule.categoryLink(id) };
    }
}
